module.exports = __webpack_public_path__ + "static/media/icon-up.0dd2ce20.svg";